module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "step-billing-overview-notification"
  }, [_vm._v(_vm._s(_vm.lang.SET401))]), _vm._v(" "), _c('div', {
    staticClass: "step-billing-overview-title"
  }, [_vm._v(_vm._s(_vm.lang.SET400))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 billing-address-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET402))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.shopperBillingAddress.Name) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.shopperBillingAddress.Street) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.shopperBillingAddress.PLZCity) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bank-details-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET403))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET407) + ":\n      " + _vm._s(_vm.bankDetailsData.BankName) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET409) + ":\n      " + _vm._s(_vm.bankDetailsData.SwiftCode) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET408) + ":\n      " + _vm._s(_vm.bankDetailsData.AccountNumber) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET410) + ":\n      " + _vm._s(_vm.bankDetailsData.AccountName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET404))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET405))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET406))]), _vm._v(" "), (!_vm.vatNotMandatory) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SET412) + " (" + _vm._s(_vm.shopperCart.CartItems[0].VatRate * 100) + "%)\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET413))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shopperCart.CartItems), function(cartItem) {
    return _c('tr', {
      key: cartItem.CartItemGuid
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(cartItem.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(cartItem.SurveyTitle))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(cartItem.Total, "EUR")) + "\n            ")]), _vm._v(" "), (!_vm.vatNotMandatory) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(cartItem.VatValue, "EUR")) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(cartItem.PurchaseMoney, "EUR")) + "\n            ")])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-background"
  }, [_c('td', {
    staticClass: "align-total-text format-total-text",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SET411) + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(_vm.shopperCart.Total, "EUR")) + "\n            ")]), _vm._v(" "), (!_vm.vatNotMandatory) ? _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(_vm.shopperCart.TotalVatValue, "EUR")) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(
    _vm.shopperCart.TotalPurchaseMoney,
    "EUR"
  )) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "payout-background"
  }, [_c('td', {
    staticClass: "align-total-text format-total-text",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SET414) + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text",
    attrs: {
      "colspan": _vm.vatNotMandatory ? 2 : 3
    }
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(
    _vm.shopperCart.TotalWithVatAndPurchaseMoney,
    "EUR"
  )) + "\n            ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3b013bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settlement/CheckoutSteps/BillingOverview.vue
// module id = 423
// module chunks = 1 2